export default function SubpageTitle({ children }: { children: string }) {
  return (
    <span className="font-bold text-transparent text-[40px] max-2xl:text-[32px] max-md:text-xl bg-clip-text bg-gradient-to-r from-[#FF4E83] to-[#FFBB54]">
      {children}
    </span>
  );
}
